import { render, staticRenderFns } from "./ArticleSlider.vue?vue&type=template&id=54503dba"
import script from "./ArticleSlider.vue?vue&type=script&lang=js"
export * from "./ArticleSlider.vue?vue&type=script&lang=js"
import style0 from "./ArticleSlider.vue?vue&type=style&index=0&id=54503dba&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54503dba')) {
      api.createRecord('54503dba', component.options)
    } else {
      api.reload('54503dba', component.options)
    }
    module.hot.accept("./ArticleSlider.vue?vue&type=template&id=54503dba", function () {
      api.rerender('54503dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/ArticleSlider.vue"
export default component.exports